const subPageHeight = 61;

export default subPageHeight;
